
import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

const ContactThankYou: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Thank You | SaunaDip</title>
        <meta name="description" content="Thank you for contacting SaunaDip" />
        <meta name="robots" content="noindex" />
      </Helmet>
      
      <div className="bg-sauna-beige min-h-screen py-12 px-4">
        <div className="max-w-3xl mx-auto text-center">
          <CheckCircle2 size={80} className="mx-auto mb-6 text-sauna-orange" />
          
          <h1 className="text-4xl font-bold text-sauna-navy mb-6">Thank You for Reaching Out!</h1>
          
          <Card className="mb-8 shadow-md border-0">
            <CardContent className="pt-6">
              <div className="space-y-6">
                <p className="text-xl">
                  We truly appreciate you taking the time to contact us.
                </p>
                
                <div className="bg-sauna-orange/10 rounded-lg p-4 text-sauna-navy text-md border border-sauna-orange/20">
                  <p>Your message has been received and we're excited to connect with you!</p>
                  <p className="mt-2">We will do our best to respond as soon as possible, typically within 24-48 hours.</p>
                </div>
                
                <div className="grid gap-6 md:grid-cols-2 mt-8">
                  <div className="bg-white p-6 rounded-lg border border-gray-100 text-left">
                    <h3 className="font-semibold text-lg mb-3">What's Next?</h3>
                    <ul className="space-y-3 text-gray-600">
                      <li className="flex items-start gap-2">
                        <div className="rounded-full bg-sauna-orange/10 p-1 mt-0.5">
                          <span className="text-sauna-orange text-xs font-bold">1</span>
                        </div>
                        <span>Our team will review your message</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <div className="rounded-full bg-sauna-orange/10 p-1 mt-0.5">
                          <span className="text-sauna-orange text-xs font-bold">2</span>
                        </div>
                        <span>We'll respond to your inquiry via email</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <div className="rounded-full bg-sauna-orange/10 p-1 mt-0.5">
                          <span className="text-sauna-orange text-xs font-bold">3</span>
                        </div>
                        <span>We'll work together to address your needs</span>
                      </li>
                    </ul>
                  </div>
                  
                  <div className="bg-white p-6 rounded-lg border border-gray-100 text-left">
                    <h3 className="font-semibold text-lg mb-3">In the Meantime</h3>
                    <p className="text-gray-600 mb-4">
                      Feel free to explore our directory to discover amazing sauna and plunge experiences.
                    </p>
                    <Button asChild variant="outline" className="w-full">
                      <Link to="/directory">Explore Directory</Link>
                    </Button>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
          
          <div className="space-y-4">
            <Button 
              asChild
              size="lg" 
              className="bg-sauna-orange hover:bg-sauna-orange/90 px-8"
            >
              <Link to="/">
                <Home className="mr-2" size={18} />
                Back to Homepage
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactThankYou;
